module.exports = __webpack_public_path__ + "media/promo/courses/images/access1-f7a313ba5db33a5868c2dc993fa9cf10.jpg";